// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


// Style the <dmixer-sale-badge> web component's shadow DOM content
(function () {
  // Full CSS rules injected into the shadow root itself. Use !important
  // where you need to beat the wrapper's inline style attribute.
  const customCSS = `
    .dmixer-sale-badge-text {
      font-family: var(--font-menu-family) !important;
      font-weight: var(--font-menu-weight) !important;
      text-transform: var(--navigation-transform) !important;
      letter-spacing: var(--font-menu-ls) !important;
      font-size: var(--font-menu-size) !important;
    }
  `;
  // ------------------------------------------------------

  function applyBadgeStyles(host) {
    if (!host || host.dataset.dmixerStyled === "true") return;

    const shadowRoot = host.shadowRoot;
    if (!shadowRoot) return;

    const wrapper = shadowRoot.querySelector(".dmixer-sale-badge-wrapper");
    if (!wrapper) return;

    // Inject a <style> tag into the shadow root for class-based rules
    if (!shadowRoot.querySelector("style[data-dmixer-custom]")) {
      const styleTag = document.createElement("style");
      styleTag.setAttribute("data-dmixer-custom", "true");
      styleTag.textContent = customCSS;
      shadowRoot.appendChild(styleTag);
    }

    host.dataset.dmixerStyled = "true";
  }

  function styleAllBadges() {
    document
      .querySelectorAll("dmixer-sale-badge")
      .forEach((host) => applyBadgeStyles(host));
  }

  // Style any badges already present on load
  styleAllBadges();

  // Watch for badges added later (async app injection, AJAX cart, etc.)
  const observer = new MutationObserver(() => {
    styleAllBadges();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
